import { render, staticRenderFns } from "./ReportGroup.vue?vue&type=template&id=3b01eeb1&scoped=true"
import script from "./ReportGroup.vue?vue&type=script&lang=js"
export * from "./ReportGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b01eeb1",
  null
  
)

export default component.exports